
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Assurons-nous que les URLs et clés sont correctement définies
const SUPABASE_URL = "https://jhxhhccqgbpfxwhbosdm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpoeGhoY2NxZ2JwZnh3aGJvc2RtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYyMDM4MjMsImV4cCI6MjA2MTc3OTgyM30.dXW8rKAIdOkt09j2KMrPE4zu542Sp_ff16U-uZhHhvM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
